import React, { useState } from "react";
import Dashboard from "./Dashboard";
import PendingPayments from "./PendingPayments";
import ClientPortalPayments from "./ClientPortalPayments";
import MyAssignments from "./MyAssignments";
import Notifications from "./Notifications";
import { withRouter, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { getEnvVar } from "utils/env";
import NotificationsIndicator from "./Notifications/Indicator";
import Header from "components/common_components/Header";
import { Tabs } from "components/common_components/Tabs";
import { hasPermission } from "utils/session";
import { hasElements } from "utils/arrays";
import { Tenant } from "utils/tenants";

const getOptions = (user, match) => {
    const taskIdToPreload = match && match.params && match.params.id;
    const options = [];

    if (user && hasPermission(user, "home.work.access")) {
        options.push({
            index: 0,
            label: "Work",
            path: "/home/work",
            icon: "customers",
            component: <Dashboard taskIdToPreload={taskIdToPreload} />,
        });
    }

    if (user && hasPermission(user, "home.my-assignments.access")) {
        options.push({
            index: options.length,
            label: "My Assignments",
            path: "/home/my-assignments",
            icon: "customers",
            component: <MyAssignments />,
        });
    }

    if (user && hasPermission(user, "home.payments.access")) {
        options.push({
            index: options.length,
            label: "Pending Payments",
            path: "/home/pending-payments",
            icon: "payments",
            component: <PendingPayments />,
        });
    }

    if (user && hasPermission(user, "home.notifications.access")) {
        options.push({
            index: options.length,
            label: "Notifications",
            path: "/home/notifications",
            icon: "notification",
            component: <Notifications />,
            notificationsKeyIdentity: getEnvVar("VITE_CHAT_IDENTITY"),
        });
    }

    if (user && hasPermission(user, "home.payments.access")) {
        options.push({
            index: options.length,
            label: "Client Portal Payments",
            path: "/home/cp-payments",
            icon: "payments",
            key: "cp-payments",
            component: <ClientPortalPayments />,
        });
    }

    return options;
};

function Home({ match }) {
    const { user } = useSelector((state) => state.Login);
    const location = useLocation();
    const cpPaymentsTab = location.state?.cpPaymentsTab;

    const initialOption = () => {
        const opts = getOptions(user, match);
        if (cpPaymentsTab) {
            const cpTab = opts.find((o) => o.key === "cp-payments");
            if (cpTab) return cpTab;
        }
        return opts[0];
    };

    const [selectedOption, setSelectedOption] = useState(initialOption);

    function handleChange(_, newIndex) {
        const newSelectedOption = getOptions(user, match).find((o) => o.index === newIndex);
        if (newSelectedOption) {
            setSelectedOption(newSelectedOption);
        }
    }

    const renderTabLabel = (label, notificationsKeyIdentity) => {
        if (notificationsKeyIdentity) {
            return (
                <>
                    {label}
                    <NotificationsIndicator id="home" identity={notificationsKeyIdentity} className="in-tab" />
                </>
            );
        }
        return label;
    };

    if (Tenant.getFeatures().home.enabled === false) {
        return <div className="home-welcome">Welcome!</div>;
    }

    const options = getOptions(user, match);

    if (!hasElements(options)) {
        return null;
    }

    return (
        <>
            <Header title="Home" />
            <Tabs options={options} selectedOption={selectedOption} onChange={handleChange} renderTabLabel={renderTabLabel} />
        </>
    );
}

export default withRouter(Home);
